// extracted by mini-css-extract-plugin
export default {"card":"M7-z"};